import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
// tslint:disable-next-line: import-blacklist
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';


@Injectable()
export class AppConfigService {
 // baseUrl: String = 'http://localhost:60664/';
  
  navDocumentElement: HTMLElement;
  documentSubNav: HTMLElement;
  constructor(private _http: HttpClient) {
  }
 

  getLanguageList(): any {
    return this._http.get(environment.APIEndpoint +'api/Language/GetLanguageList')
      .map((res) => res)
      .catch(this._errorHandler);
  }
  _errorHandler(error: Response) {
    // tslint:disable-next-line: deprecation
    return Observable.throw(error || 'Server Error');
  }

  GetEngagementLanguageList(): any {
    return this._http.get(environment.APIEndpoint +'api/Language/GetEngagementLanguageList')
      .map((res) => res)
      .catch(this._errorHandler);
  }

  addLanguage(newarray) {
    const url_ = (environment.APIEndpoint+'api/Language/AddLanguage');
    const params = new URLSearchParams();
    params.set('newarray', newarray);
    return this._http.post(url_, newarray)
      .map(
        result => {
          console.log(result);
        },
        error => {
          console.log('There was an error: ');
        }
      );
 }

  removeLanguage(languageid) {
    const url_ = (environment.APIEndpoint+'api/Language/RemoveLanguage?languageId=' + languageid);
    const params = new URLSearchParams();
    params.set('languageid', languageid);
    return this._http.get(url_)
      .map(
        result => {
          console.log(result);
        },
        error => {
          console.log('There was an error: ');
        }
      );
}

}
